import { IApplicationState } from '../../types/redux';
import { getFilters } from './getFilters';

export function getMinArea(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.minArea;
}

export function getMaxArea(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.maxArea;
}
